import { Component, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'

@Component({
  selector: 'app-orders-shipping-detail',
  templateUrl: './orders-shipping-detail.component.html',
  styleUrls: ['./orders-shipping-detail.component.scss']
})
export class OrdersShippingDetailComponent implements OnInit {

  listZonesCoord: any[];
  selectedProduct: any;
  text: string;

  secondTabDisabled: boolean;
  thirdTabDisabled: boolean;
  fourthTabDisabled: boolean;
  indexTab: number = 0;
  billCols: any[];
  billData: any[];
  productData: any[];
  productCols: any[];


  constructor() { }

  ngOnInit(): void {

    this.secondTabDisabled = true;
    this.thirdTabDisabled = true;

    this.listZonesCoord = [
      { id: "0001", descript: "LIBRO ENCUENTROS", provedoor: "Provedor Pruebas", multiple: "216", unidadMed: "pieza", cantReq: "100", cantPen: "50", cantEnvio: "50", rango: null, coment: "Prueba commnet", package: "0.05" },
      { id: "0002", descript: "FOLDER/PRACTICA SEMANAL TOV ADULTOS", provedoor: "Provedor Pruebas", multiple: "100", unidadMed: "(multiplos 100)", cantReq: "95", cantPen: "5", cantEnvio: "90", rango: null, coment: "Prueba commnet", package: "0.05" },
    ];

    this.billCols = [
      { field: 'billTo', header: 'BILL TO' },
      { field: 'date', header: 'DATE' },
      { field: 'email', header: 'INVOICE NO' },
      { field: 'notes', header: 'NOTES' }
    ];

    this.billData = [
      {
        'billTo': 'Calle 47 # 401 A Por 34 Y 36 Colonia Industrial Mérida, Mexico, Código postal 97150, Números de teléfono (999)1000063, 777777777',
        'date': '30/08/2021',
        'email': 'faustacasanova56@gmail.com',
        'notes': 'Coordinación: 015 México Península'
      }
    ];

    this.productCols = [
      { field: 'cantEnvio', header: 'Cantidad' },
      { field: 'id', header: 'Id' },
      { field: 'descript', header: 'Descripcion' },
      { field: 'coment', header: 'Comentarios' }
    ];

  }

  results: string[];

  search(event) {
    this.results = ["0001 LIBRO ENCUENTRO", "0002 FOLDER/PRÁCTICA SEMANAL TOV ADULTOS  (múltiplos 100)", "0003 FOLDER/PRÁCTICA SEMANAL TOV ADULTOS 1 A 4   (múltiplos 100)", "0004 CANTORAL DEL TALLERISTA"]

  }

  onRowEditInit(product: any) {
  }

  onRowEditSave(product: any) {
    if (product.price > 0) {

    }
    else {
    }
  }

  onRowEditCancel(product: any, index: number) {

  }

  handleNextFirstTab(event) {
    //Validate info and then active the second Tab
    this.secondTabDisabled = false;
    this.indexTab = 1;
  }

  handleNextSecondTab(event) {
    //Validate info and then active the second Tab
    this.thirdTabDisabled = false;
    this.indexTab = 2;
  }

  handleBackSecondTab(event) {
    //Validate info and then active the second Tab
    this.secondTabDisabled = false;
    this.indexTab = 0;
  }

  handleNextThirdTab(event) {
    //Validate info and then active the second Tab
    this.fourthTabDisabled = false;
    this.indexTab = 3;
  }

  handleBackThirdTab(event) {
    //Validate info and then active the second Tab
    this.secondTabDisabled = false;
    this.indexTab = 1;
  }

  handleNextFourthTab(event) {
    //Validate info and then active the second Tab
    this.secondTabDisabled = false;
    this.indexTab = 2;
  }



  exportPdf() {
    let headerPDF: any[] = [["ID Articulo", "Descripción", "Proveedor", "multiple_", "Unidad de med", "Cant Requerida"]];
    let data: any[] = [["0001", "LIBRO ENCUENTROS", " Provedor Pruebas ", "216", "pieza", "100"]];
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}${month}${day}`;

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default('landscape', 'cm', 'a4');

        autoTable(
          doc, {
          head: headerPDF,
          body: data,
          didDrawCell: (data) => {
          },
        });
        doc.save('listOrdersShipping_' + formattedDate + '.pdf');
      })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.listZonesCoord);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "products-order-ship");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}${month}${day}`;

    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, 'listOrdersShipping_' + formattedDate + '.xlsx');
  }

  print() {
    window.print();
  }

}
